// note: i do not need to reload the same page anymore if i switch from cpl to desktop version because both markups exist and are not replaced when resizing as before

var shortcodes_controller = {
	pageContainsShortcode: function (stateObj) {
		return pageContainsShortcode(stateObj)
	},
}

export default shortcodes_controller

// this function finds out if the page that is about to be loaded contains a shortcode

// need to reload cause some shortcodes only work when document ready was called
var pageContainsShortcode = function (stateObj) {
	var state = stateObj
	// state is null when anchorlink was clicked #, bc then the browser fires popstate with an empty state
	if (state == null) {
		return false
	}
	var id = state.id
	var type = state.type

	var footerIdToCheck = false

	// find out if a shortcode is in the current footer
	switch (type) {
		case 'project':
			var footer_active_in_projects = layData.footer_active_in_projects
			if (footer_active_in_projects == 'all') {
				footerIdToCheck = layData.projectsFooterId
			} else if (footer_active_in_projects == 'individual') {
				if (layData.individual_project_footers != '') {
					var obj = JSON.parse(layData.individual_project_footers)

					// thats what the obj looks like: [postid] => [footerid]
					// (
					//     [35] =>
					//     [34] => 35
					//     [6] => 35
					// )

					// we just need the footerid of the current post
					if (obj != null && typeof obj == 'object' && typeof obj[id] != 'undefined') {
						footerIdToCheck = obj[id]
					}
				}
			}
			break
		case 'page':
			var footer_active_in_pages = layData.footer_active_in_pages
			if (footer_active_in_pages == 'all') {
				footerIdToCheck = layData.pagesFooterId
			} else if (footer_active_in_pages == 'individual') {
				if (layData.individual_page_footers != '') {
					var obj = JSON.parse(layData.individual_page_footers)
					if (obj != null && typeof obj == 'object' && typeof obj[id] != 'undefined') {
						footerIdToCheck = obj[id]
					}
				}
			}
			break
		case 'category':
			var footer_active_in_categories = layData.footer_active_in_categories
			if (footer_active_in_categories == 'all') {
				footerIdToCheck = layData.categoriesFooterId
			} else if (footer_active_in_categories == 'individual') {
				if (layData.individual_category_footers != '') {
					var obj = JSON.parse(layData.individual_category_footers)
					if (obj != null && typeof obj == 'object' && typeof obj[id] != 'undefined') {
						footerIdToCheck = obj[id]
					}
				}
			}
			break
	}

	var shortcodes = layData.shortcodes
	if (jQuery.isArray(shortcodes) && footerIdToCheck != false) {
		for (var i = 0; i < shortcodes.length; i++) {
			var occurence = shortcodes[i]
			if (occurence['info']['type'] == 'post' && occurence['info']['id'] == footerIdToCheck) {
				return true
			}
		}
	}

	// find out if a shortcode is in the current page/project/category

	// my shortcode info obj has only type "post" or "category"
	if (type == 'project' || type == 'page') {
		type = 'post'
	}
	if (jQuery.isArray(shortcodes)) {
		for (var i = 0; i < shortcodes.length; i++) {
			if (shortcodes[i]['info']['type'] == type && shortcodes[i]['info']['id'] == id) {
				return true
			}
		}
	}
	return false
}
